import { gql } from '@apollo/client';
import { GET_QUALIFIERS } from '../../../pages/ArticleEdit/DrawerContent/getQualifers.web.graphql';
import { useCreate, useUpdate } from '../../../utils/useUpdateCreate';
import {
  QualifierUpdateInput,
  QualifierCreationInput,
  UpdateQualifierMutation,
  CreateQualifierMutation,
} from '../../../__generated__/queries-web';
import { GET_QUALIFIER } from './getQualifier.web.graphql';

const UPDATE_QUALIFIER = gql`
  mutation UpdateQualifier(
    $where: QualifierUniqueFilterInput!
    $data: QualifierUpdateInput!
  ) {
    updateQualifier(where: $where, data: $data) {
      id
    }
  }
`;

export const useUpdateQualifier = () =>
  useUpdate<UpdateQualifierMutation, QualifierUpdateInput>(UPDATE_QUALIFIER, [
    GET_QUALIFIER,
  ]);

const CREATE_QUALIFIER = gql`
  mutation CreateQualifier($data: QualifierCreationInput!) {
    createQualifier(data: $data) {
      id
    }
  }
`;

export const useCreateQualifier = () =>
  useCreate<CreateQualifierMutation, QualifierCreationInput>(CREATE_QUALIFIER, [
    GET_QUALIFIERS,
  ]);
